"use client"

import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const labelVariants = cva(
  "text-sm font-regular mb-1.5 block font-wireless leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {variants:{
    variant:{
      primary:"text-midnightIndigo-300 font-[14px] line-height-[21px]  font-wireless font-normal md:font-[15px] ",
      secondary:"text-midnightIndigo-400",
    },
  
  },

  defaultVariants:{
    variant:"primary"
  }
}
)

const Label = React.forwardRef(({ className,variant, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants({variant}), className)} {...props} />
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
